export default "__VITE_ASSET__BUjea1Rg__"